import React from "react";
import logo from "../assets/logo.svg";

const Header = () => {
  return (
    <header className="py-8">
      <div className="container mx-auto">
        <div className="flex justify-between items-center">
          <a href="#">
            <img src={logo} alt="logo" />
          </a>
          <a href="#contact">
            <button className="btn btn-sm">Get in touch</button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
